// index.js
import * as uploads from './uploads';
import * as users from './users';
import * as buy from './buy';
import * as s3Templates from './s3Templates';
import * as s3UserImages from './s3UserImages';
import * as receipts from './receipts';
import * as paypal from './paypal';
import * as modal from './modal';

export {
  s3Templates,
  s3UserImages,
  buy,
  uploads,
  users,
  receipts,
  paypal,
  modal
};



// WEBPACK FOOTER //
// ./src/store/actions/index.js